import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import Select from '@Form/Select'
import Input from '@Form/Input'

import QuestionWeight from './model/QuestionWeight'
import FixedWeight from './model/FixedWeight'

@observer
class Weight extends Component {
    constructor(props) {
        super(props)

        this.state = {
            model: {
                type: '',
                questionId: null,
            },
        }

        props.register(this.getValue)
    }

    getValue = () => (
        R.pathOr(0, ['model', 'value'], this.state)
    )

    changeVariable = ({ name, value }) => {
        const { variable } = this.props
        const { weight } = variable
        // const modelCopy = R.clone(this.state.model)

        weight[name] = value
        // this.setState({
        //     model: modelCopy,
        // })
    }

    changeType = ({ name, value }) => {
        const { variable } = this.props
        if (value === 'question') {
            variable.weight = new QuestionWeight({})
        } else {
            variable.weight = new FixedWeight({})
        }
    }

    render() {
        const { questions, testFormula, variable } = this.props
        const { weight } = variable
        const { kind } = weight

        return (
            <Fragment>
                {/* <label>Weight</label> */}
                <div
                    style={{
                        padding: '10px',
                        margin: '5px 0px',
                        border: '1px solid #CCC',
                        borderRadius: '8px',
                    }}
                >
                    {testFormula && (
                        <Input
                            label="Weight"
                            name="value"
                            onBlur={(field) => this.changeVariable(field)}
                            placeholder="Please enter a value"
                        />
                    )}
                    {!testFormula && (
                        <Fragment>
                            {/* <label>Type</label> */}
                            <Select
                                label="Type"
                                options={[
                                    {
                                        value: 'fixed',
                                        label: 'Fixed',
                                    },
                                    {
                                        value: 'question',
                                        label: 'Question',
                                    },
                                ]}
                                defaultValue={weight.kind}
                                onBlur={(field) => this.changeType(field)}
                                name="kind"
                            />
                            <br />
                            {kind === 'fixed' && (
                                <Input
                                    name="value"
                                    onBlur={(field) => this.changeVariable(field)}
                                    defaultValue={0}
                                    defaultValue={weight.value}
                                    placeholder="Please enter a weight"
                                />
                            )}
                            {kind === 'question' && (
                                <Fragment>
                                    {/* <label>Question</label> */}
                                    <Select
                                        label="Question"
                                        options={questions}
                                        onBlur={(field) => this.changeVariable(field)}
                                        name="questionId"
                                        defaultValue={weight.questionId}
                                    />
                                    {/* <label>Adjustment</label> */}
                                    <br />
                                    <Input
                                        label="Adjustment"
                                        name="adjustment"
                                        onBlur={(field) => this.changeVariable(field)}
                                        placeholder="Please enter an adjustment"
                                        defaultValue={weight.adjustment}
                                    />
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </div>
            </Fragment>
        )
    }
}

export default Weight
